import { Widget, mk_widget, Action } from "widgets-for-react";
import * as React from "react";
import { PublicSiteState } from "../../public_site.main.mod";
import NavItems from "./nav_items_footer";
import { t } from "i18next";
import { AppState } from "../../cms/state/types.gen";
import { PublicSiteCustomRoutes } from "../custom_pages/types.mod";
import Wave from "react-wavify";
import { enableReducedMotion } from "../custom_pages/Fc150YearsWidget/Fc150Years.utils";
import { NavLink } from "react-router-dom";
import { loader } from "./loader.mod";

declare var Optanon;

export const footer: (
  s: AppState<PublicSiteState, PublicSiteCustomRoutes>
) => Widget<
  Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
> = props =>
  mk_widget({
    run: setState => {
      footerRequestAnimationFrame();

      let wavePaused: boolean = enableReducedMotion;
      const headerBlock = props.state.Fc150YearsMainPage.state.page.blocks && props.state.Fc150YearsMainPage.state.page.blocks.size > 0 && props.state.Fc150YearsMainPage.state.page.blocks.get(0) as any;
           
      if((
        ((props.state.Fc150YearsMainPage.current_page == 'homepage' || props.state.Fc150YearsMainPage.transition.to.current_page == 'homepage') && props.state.Fc150YearsMainPage.homeState.splashState != 'no-show') ||
        props.state.header.menu == 'open' ||
        (headerBlock && headerBlock.kind == "headerBlock" && headerBlock.value.fst.video_playing == true)
      )) {
        wavePaused = true;
      }

      return (
        <>
          <footer className={`footer ${(props.state.Fc150YearsMainPage.current_page == 'story-detail-page' || props.state.Fc150YearsMainPage.transition.to.current_page == 'story-detail-page') ? 'footer--story' : 'footer--default'}`}>
            <div className="footer__inner">
              {(
                props.state.Fc150YearsMainPage.current_page == 'homepage' ||
                (props.state.Fc150YearsMainPage.current_page == 'stories-overview-page' && !props.state.Fc150YearsMainPage.storiesOverviewState.isAbout) ||
                (props.state.Fc150YearsMainPage.current_page == 'transition-page' &&
                  (
                  ((props.state.Fc150YearsMainPage.transition.to.current_page == 'homepage' || (props.state.Fc150YearsMainPage.transition.to.current_page == 'stories-overview-page' && !props.state.Fc150YearsMainPage.transition.to.storiesOverviewState.isAbout)) &&
                    (props.state.Fc150YearsMainPage.transition.animationState == 'wave-moving-down'))
                  ||
                  ((props.state.Fc150YearsMainPage.transition.from.v.kind == 'r' && (props.state.Fc150YearsMainPage.transition.from.v.v.current_page == 'homepage' || (props.state.Fc150YearsMainPage.transition.from.v.v.current_page == 'stories-overview-page' && !props.state.Fc150YearsMainPage.transition.from.v.v.storiesOverviewState.isAbout))) &&
                    (props.state.Fc150YearsMainPage.transition.animationState == 'about-to-move-up' || props.state.Fc150YearsMainPage.transition.animationState == 'wave-moving-up'))
                )
                )
              ) ? (
                <div className='footer__top'>
                    <Wave fill='rgb(255, 255, 255, .5)'
                      paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                      options={{
                        height: 60,
                        amplitude: 10,
                        speed: 0.1,
                        points: 8
                      }}
                      className="footer__wave"
                    />
                    <Wave fill='rgb(255, 255, 255, .65)'
                      paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                      options={{
                        height: 60,
                        amplitude: 10,
                        speed: 0.1,
                        points: 5
                      }}
                      className="footer__wave"
                    />

                    <div className="footer__scroll">
                      <p className="footer__indicator typo--4xs">Scroll to explore</p>
                      <svg className="footer__chrevron" viewBox="0 0 24 15" width="24" height="15" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="m966 105.753999-12-10.5000001 12-10.5" fill="none" stroke="#0094d9" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" transform="matrix(0 -1 1 0 -83.253999 967.5)" /></svg>
                    </div>
                  </div>
              ) : (
                <></>
              )}

              {(
                (props.state.Fc150YearsMainPage.current_page == 'stories-overview-page') ||
                (
                  props.state.Fc150YearsMainPage.current_page == 'transition-page' &&
                  props.state.Fc150YearsMainPage.transition.to.current_page == 'stories-overview-page' &&
                  props.state.Fc150YearsMainPage.transition.from.v.kind == 'r' &&
                  props.state.Fc150YearsMainPage.transition.from.v.v.current_page == 'stories-overview-page' &&
                  (props.state.Fc150YearsMainPage.transition.animationState == 'about-to-move-up' || props.state.Fc150YearsMainPage.transition.animationState == 'wave-moving-up')
                )

              ) && !props.state.Fc150YearsMainPage.storiesOverviewState.isAbout && <div className="footer__center">
                <div className="footer__content footer__themes">
                  <h2 className="footer__themestitle typo--l">More themes to explore:</h2>

                  <ul className="footer__themeslist">
                    {props.state.Fc150YearsMainPage.pagesloader.kind == 'loaded' ?
                      props.state.Fc150YearsMainPage.pagesloader.value.map(page => {
                        if (page.slug != props.state.Fc150YearsMainPage.storiesOverviewState.title) {
                          let taxonomy = page._embedded["wp:term"].length > 0 && page._embedded["wp:term"][0].length > 0 ? page._embedded["wp:term"][0][0] : undefined

                          return <li key={page.id} className={`footer__theme theme--${taxonomy?.slug}`}>
                            <NavLink className="footer__themelink" to={`${props.route.kind == "Fc150YearsMainPage" ? "/" + props.route.lang : ""}/${page.slug}/?taxonomy=${taxonomy?.id}`}>
                              <h3 className="footer__themetitle typo--3xl">{taxonomy?.name}</h3>
                              <div className="themeicon footer__themevisual" aria-hidden="true">
                                <div className="themeicon__icon footer__themeicon">
                                  <img className="themeicon__bg footer__themebg lazyload" width="320" height="180" alt=""
                                    src="/frontend/images/empty.png"
                                    data-src={`/frontend/images/themes/bg--${taxonomy?.slug}-640w.jpg`}
                                  />
                                </div>
                              </div>
                            </NavLink>
                          </li>
                        }
                        return null 
                      })
                      : loader.run(() => { })}
                  </ul>
                </div>
              </div>}

              <div className="footer__bottom">
                <div className="footer__content">
                  <div className="footer__content-inner">
                    <div className="footer__logos">
                      {
                        props.state.Fc150YearsMainPage.current_page == '404' ?
                          <a className="footer__link" href={window.wp.language == 'en' ? "/" : "/nl"}>
                            <span className="sr-text">{window.wp.language == 'en' ? "Return to homepage of FrieslandCampina 150 years" : "Keer terug naar homepage van FrieslandCampina 150 jaar"}</span>
                            <img className="footer__logo lazyload" alt="" width="361" height="133" aria-hidden="true"
                              src="/frontend/images/empty.png"
                              data-src="/frontend/images/logo--footer.svg"
                            />
                          </a> :
                          <NavLink className="footer__link" to={window.wp.language == 'en' ? "/" : "/nl"}>
                            <span className="sr-text">{window.wp.language == 'en' ? "Return to homepage of FrieslandCampina 150 years" : "Keer terug naar homepage van FrieslandCampina 150 jaar"}</span>
                            <img className="footer__logo lazyload" alt="" width="361" height="133" aria-hidden="true"
                              src="/frontend/images/empty.png"
                              data-src="/frontend/images/logo--footer.svg"
                            />
                          </NavLink>
                      }
                    </div>

                    <div className="footer__menu">
                      <div className="footer__text typo--xs" dangerouslySetInnerHTML={{ __html: t("footer.text") }} />

                      <NavItems location='copyright' s0={props.state} after={
                        <li className="footer__menuitem">
                          <a onClick={() => Optanon.ToggleInfoDisplay()} className="footer__menulink">Cookie settings</a>
                        </li>
                      } />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </>
      )
    }
  });

export let footerCurrentScroll: number = 0;
export let footerAnimFrameId: number = null;

function footerRequestAnimationFrame() {
  // Exit and restart the scrollHandling if there was no difference in scroll
  if (window.scrollY == footerCurrentScroll) {
    handleStickyFooter('init'); // Init the footer once to show correct values on page load
    footerAnimFrameId = requestAnimationFrame(footerRequestAnimationFrame);
    return;
  }

  // ----- STICKY FOOTER -----
  handleStickyFooter('runtime');
  // ----- end STICKY FOOTER -----

  footerCurrentScroll = window.scrollY;
  footerAnimFrameId = requestAnimationFrame(footerRequestAnimationFrame); // Restart the scrollHandling
  return;
}

function handleStickyFooter(type: 'init' | 'runtime') {
  if (document.documentElement.classList.contains('splash--open')) { return; }

  const footer: HTMLElement = document.querySelector('.footer');
  const footerTop: HTMLElement = document.querySelector('.footer__top');

  if ((
    (footer == null || footerTop == null) ||
    // (type == 'init' && footer != null && footer.classList.contains('init')) ||
    (footer != null && (footer.getBoundingClientRect().top + 125) == 0)
  )) {
    return;
  }

  if ((footer.getBoundingClientRect().top + 125) < window.innerHeight) {
    footerTop.classList.remove('sticky');
  } else {
    footerTop.classList.add('sticky');
  }

  if (!footer.classList.contains('init')) {
    footer.classList.add('init');
  }
}
